import axios from "axios";
import { API } from "./api";

export const vendorApi = axios.create({ baseURL: API });
vendorApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("vsb_vendor_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const vendorStore = {
  save(token, vendor) {
    localStorage.setItem("vsb_vendor_token", token);
    if (vendor) localStorage.setItem("vsb_vendor", JSON.stringify(vendor));
  },
  saveRegToken(token) { localStorage.setItem("vsb_vendor_reg_token", token); },
  regToken() { return localStorage.getItem("vsb_vendor_reg_token"); },
  clearRegToken() { localStorage.removeItem("vsb_vendor_reg_token"); },
  token() { return localStorage.getItem("vsb_vendor_token"); },
  vendor() {
    try { return JSON.parse(localStorage.getItem("vsb_vendor") || "null"); }
    catch { return null; }
  },
  clear() {
    localStorage.removeItem("vsb_vendor_token");
    localStorage.removeItem("vsb_vendor");
    localStorage.removeItem("vsb_vendor_reg_token");
  },
};
